import CollectionService from '@boServices/collectionService';
import { useEffect, useState } from 'react';

const collectionService = new CollectionService();

const languageToOption = (l) => ({ value: l.id, label: l.nom });

const useTagOptions = () => {
    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        collectionService
            .getLangues()
            .then((data) => setLanguagesOptions((Array.isArray(data) ? data : []).map(languageToOption)))
            .catch(setError)
            .finally(() => setLoading(false));
    }, []);

    return { languagesOptions, loading, error };
};

export default useTagOptions;
